$(() => {
  const lead_params = capture_url_params();

  if (Object.keys(lead_params).length > 0) {
    $('#pardot-form-modal .modal-header h3').text('Is your information correct?');
    populate_pardot_form_with_lead_info(lead_params);
  }

  function capture_url_params() {
    const url_params = new URLSearchParams(window.location.search);

    if (!url_params.has('email')) {
      return {};
    }

    return {
      email: url_params.get('email')
    };
  }

  function populate_pardot_form_with_lead_info(params) {
    $('#email').val(params.email);
  }

  $('body').on('click', '#save-my-report-btn', (event) => {
    event.preventDefault();
    const pdf_url = $('#prospect-pdf-url').val();
    // const cvm_session_id = $('#cvm-session-id').val();

    // // eslint-disable-next-line no-useless-escape
    const email_regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    // const email_input = $('#287622_157708pi_287622_157708');
    // if (!email_regex.test(email_input.val())) {
    //   email_input.addClass('is-invalid');
    //   email_input.closest('label').addClass('text-danger');
    //   return;
    // }

    email_input.removeClass('is-invalid');
    email_input.closest('label').removeClass('text-danger')

    $('#sent-prospect-email').val('true');
    $('#calculator-form').submit();

    window.open(pdf_url, '_blank');
    $('#pardot-form').submit();
  });
});
